import moment from 'moment';

export function orderTarget(targetArray: any[]): string {
  if(!targetArray || targetArray.length == 0) return 'Unplanned';
  else {
    const currentMonth = moment().format('MMM');
    const targetStrings: string[] = targetArray.map((targetObject: any) => {
      const targetMonth = moment(targetObject.month).format('MMM');
      if(targetMonth == currentMonth) {
        return 'In Target'
      } else {
        return 'Unplanned';
      }
    });
    const inTarget = targetStrings.find((targetString: string) => targetString == 'In Target')
    return inTarget || 'Unplanned';
  }
}